var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCompetition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 252 213",
    style: {
      enableBackground: "new 0 0 252 213"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244,53.6c0-10.42-7.09-19.33-17.23-21.67L130.31,9.67c-1.62-0.36-3.27-0.54-4.91-0.54c-1.64,0-3.29,0.18-5,0.56 L24.04,31.93C13.89,34.27,6.8,43.18,6.8,53.6s7.09,19.33,17.24,21.67l19.83,4.58v62.7c0,19.68,22.51,37.06,81.54,37.06 c59.01,0,81.54-17.38,81.54-37.06v-62.7l19.82-4.58C236.91,72.94,244,64.03,244,53.6 M192.11,142.55c0,8.2-22.24,22.24-66.71,22.24 c-44.48,0-66.71-14.04-66.71-22.24V83.27l61.8,14.26c1.63,0.36,3.28,0.54,4.91,0.54c1.64,0,3.29-0.18,5.01-0.57l61.7-14.24V142.55z  M127.06,83.06c-0.55,0.12-1.1,0.19-1.67,0.19c-0.56,0-1.12-0.06-1.66-0.19L27.37,60.83c-3.36-0.77-5.74-3.77-5.74-7.22 c0-3.46,2.38-6.45,5.74-7.22l96.37-22.24c0.55-0.12,1.1-0.18,1.66-0.18c0.56,0,1.11,0.06,1.67,0.18l96.36,22.24 c3.38,0.77,5.75,3.77,5.75,7.22c0,3.45-2.37,6.46-5.75,7.22L127.06,83.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.76,68.43v66.71c0,4.1,3.33,7.41,7.41,7.41c4.09,0,7.41-3.32,7.41-7.41V68.43c0-4.1-3.33-7.41-7.41-7.41 C225.08,61.01,221.76,64.33,221.76,68.43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.17,157.47c-8.18,0-14.83,21.47-14.83,29.65c0,8.18,6.65,14.82,14.83,14.82c8.18,0,14.83-6.65,14.83-14.82 C244,178.94,237.35,157.47,229.17,157.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCompetition);
export default __webpack_public_path__ + "static/media/newCompetition.62f8c0adce19f874e21ffd1b42e2591a.svg";
export { ForwardRef as ReactComponent };